export type UserRole =
  | 'admin'
  | 'vendedor'
  | 'usuario'
  | 'empresa_admin'
  | 'empresa_operacional';

export const VENDOR_PANEL_ROLES: UserRole[] = [
  'vendedor',
  'admin',
  'empresa_admin',
  'empresa_operacional',
];

export const ADMIN_PANEL_ROLES: UserRole[] = ['admin'];

export const BUYER_PROFILE_ROLES: UserRole[] = ['usuario', 'vendedor'];

export function mapCanonicalRole(
  role?: string | null,
  tipoUsuario?: string | null,
): UserRole {
  const r = (role ?? '').toLowerCase().trim();
  const t = (tipoUsuario ?? '').toLowerCase().trim();
  if (r === 'admin' || t === 'admin') return 'admin';
  if (r === 'empresa_admin' || t === 'empresa_admin') return 'empresa_admin';
  if (r === 'empresa_operacional' || t === 'empresa_operacional') {
    return 'empresa_operacional';
  }
  if (['vendor', 'vendedor'].includes(r) || ['vendor', 'vendedor'].includes(t)) {
    return 'vendedor';
  }
  return 'usuario';
}

export function postLoginPath(role: UserRole): string {
  if (role === 'admin') return '/admin';
  if (role === 'empresa_admin' || role === 'vendedor' || role === 'empresa_operacional') {
    return '/vendedor';
  }
  return '/perfil';
}

export function unauthorizedRoleRedirect(role: UserRole): string {
  return postLoginPath(role);
}

export function showsEmpresaPanelNav(role?: string | null): boolean {
  const r = (role ?? '').toLowerCase().trim();
  return r === 'empresa_admin' || r === 'vendedor' || r === 'empresa_operacional';
}
